var map = {
    selector: '[data-map]',
    init: function () {
        var self = this;

        if (
            typeof mapboxData !== 'undefined' &&
            mapboxData.hasOwnProperty('accessToken')
        ) {
            mapboxgl.accessToken = mapboxData.accessToken;

            $(self.selector).each(function () {
                var $map = $(this),
                    key = $map.attr('data-map'),
                    $triggers = $('[data-map-trigger]');

                var mapData = mapboxData;

                var map = new mapboxgl.Map({
                    container: this,
                    style: mapboxData.style,
                    center: [mapData.center_lng, mapData.center_lat],
                    zoom: 16,
                    attributionControl: false,
                    scrollZoom: false,
                    interactive: true,
                });

                map.addControl(new mapboxgl.NavigationControl());

                if (mapData.hasOwnProperty('markers')) {
                    var markers = mapData.markers,
                        markerObjects = [];

                    var i = 0;

                    for (var marker in markers) {
                        var markerData = markers[marker],
                            markerEl = document.createElement('div');

                        if (
                            markerData.latitude === null ||
                            markerData.longitude === null
                        ) {
                            continue;
                        }

                        markerEl.className = 'map__marker';

                        var markerInner = document.createElement('div');
                        markerInner.className = 'map__marker__inner';

                        markerEl.appendChild(markerInner);

                        var markerObject = new mapboxgl.Marker(markerEl)
                            .setLngLat([
                                markerData.longitude,
                                markerData.latitude,
                            ])
                            .addTo(map);

                        i++;
                    }

                    var $markers = $map.find('.marker');
                }

                map.on('load', function () {
                    $map.addClass('map-loaded');
                });
            });
        }
    },
};

export { map };
